module.exports = __webpack_public_path__ + "img/html.ae0cf8ac.svg";